<template>
  <div class="reader-container" :class="{ mobile: isMobile }">
    <!-- 移动端菜单按钮 -->
    <button
      v-if="isMobile"
      class="menu-button"
      @click="toggleSidebar"
    >
      <svg v-if="!sidebarVisible" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
      <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

    <!-- 侧边栏 -->
    <aside
      ref="sidebarEl"
      class="sidebar"
      :class="{ visible: sidebarVisible }"
    >
      <div class="sidebar-header" v-if="isMobile">
        <button class="close-button" @click="sidebarVisible = false">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      
      <div class="sidebar-content">
        <FileTree
          :items="displayedItems"
          :selectedItem="selectedItem"
          :searchTerm="searchTerm"
          @select="onSelectItem"
        />
      </div>

      <!-- 搜索框 (悬浮在底部) -->
      <div class="sidebar-search">
        <div class="search-wrapper">
          <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input v-model="searchTerm" class="search-input" type="text" placeholder="搜索当前目录..." />
          <span v-if="searchTerm" class="clear-search" @click="searchTerm = ''">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </span>
        </div>
      </div>
    </aside>

    <!-- 遮罩层 -->
    <div 
      v-if="isMobile && sidebarVisible" 
      class="overlay"
      @click="sidebarVisible = false"
    ></div>

    <!-- 主内容区 -->
    <main class="main-content" ref="mainContentEl">
      <!-- 顶部工具栏 -->
      <div class="content-header">
        <div class="doc-info">
          <h2 v-if="selectedItem?.title" class="doc-title">
            {{ selectedItem.title.replace(/\.md$/i, '') }}
          </h2>
          <div v-if="selectedItem?.path" class="doc-meta">
            <span class="meta-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              {{ readingTime }} 分钟阅读
            </span>
            <span class="meta-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/>
              </svg>
              {{ wordCount }} 字
            </span>
            <!-- 版本选择器 -->
            <div v-if="selectedItem?.versions && selectedItem.versions.length > 1" class="version-selector">
              <span class="meta-item">版本:</span>
              <select :value="currentVersionPath" @change="switchVersion($event.target.value)" class="version-select">
                <option v-for="ver in selectedItem.versions" :key="ver.path" :value="ver.path">
                  {{ ver.label }} {{ ver.isLatest ? '(最新)' : '' }}
                </option>
              </select>
            </div>
            <span class="meta-item" v-if="docMeta.views">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
              {{ docMeta.views }} 次浏览
            </span>
            <span class="meta-item" v-if="getTags(docMeta).length > 0">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>
              </svg>
              <span class="tags-wrapper">
                <span v-for="(tag, idx) in getTags(docMeta)" :key="idx" class="doc-tag">
                  {{ tag }}
                </span>
              </span>
            </span>
          </div>
        </div>

        <div class="content-actions">
          <!-- <button class="action-button" @click="toggleTheme" title="切换主题">
            <svg v-if="isDarkTheme" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="5"/>
              <line x1="12" y1="1" x2="12" y2="3"/>
              <line x1="12" y1="21" x2="12" y2="23"/>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
              <line x1="1" y1="12" x2="3" y2="12"/>
              <line x1="21" y1="12" x2="23" y2="12"/>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          </button> -->
          
          <!-- 移动端目录按钮 -->
          <button v-if="isMobile" class="action-button" @click="showMobileToc = true" title="本页目录">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>
            </svg>
          </button>

          <button class="action-button" @click="toggleFullscreen" title="全屏">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/>
            </svg>
          </button>

          <button class="action-button" @click="copyLink" title="复制链接">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- 内容区 -->
      <div class="content-body" ref="contentBodyEl">
        <div v-if="isStillLoading" class="empty-state">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          <h3>欢迎使用文档中心</h3>
          <p>请从左侧选择一个文档开始阅读</p>
        </div>
        
        <div v-else-if="markdownLoading" class="loading-state">
          <div class="spinner"></div>
          <p>正在加载文档...</p>
        </div>
        
        <div v-else class="markdown-wrapper">
          <div class="markdown-container" :class="{ 'light-theme': !isDarkTheme }">
            <MdPreview
              v-model="markdownText"
              :theme="isDarkTheme ? 'dark' : 'light'"
              :editorId="editorId"
            />
          </div>

          <!-- 相关文档推荐 -->
          <div class="related-docs" v-if="!markdownLoading && relatedDocs.length > 0">
            <h3>相关推荐</h3>
            <div class="related-list">
              <div v-for="doc in relatedDocs" :key="doc.path" class="related-item" @click="goToRelated(doc)">
                <span class="related-icon">📄</span>
                <span class="related-title">{{ doc.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 阅读进度条 -->
      <div class="reading-progress" :style="{ width: readingProgress + '%' }"></div>
    </main>

    <!-- 回到顶部按钮 -->
    <transition name="fade">
      <button v-show="showBackToTop" class="back-to-top" @click="scrollToTop" title="回到顶部">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>
      </button>
    </transition>

    <!-- 右侧目录 (仅桌面端显示) -->
    <aside v-if="!isMobile && !isStillLoading && !markdownLoading" class="toc-sidebar">
      <div class="toc-header">
        <h3>本页目录</h3>
      </div>
      <div class="toc-content">
        <MdCatalog
          :editorId="editorId"
          :scrollElement="contentBodyEl"
          :theme="isDarkTheme ? 'dark' : 'light'"
        />
      </div>
    </aside>

    <!-- 移动端目录遮罩 -->
    <transition name="fade">
      <div v-if="isMobile && showMobileToc" class="overlay" @click="showMobileToc = false" style="z-index: 1001;"></div>
    </transition>

    <!-- 移动端目录侧边栏 -->
    <aside class="toc-sidebar mobile-toc" :class="{ visible: isMobile && showMobileToc }">
      <div class="toc-header">
        <h3>本页目录</h3>
        <button class="close-button" @click="showMobileToc = false">✕</button>
      </div>
      <div class="toc-content" @click="showMobileToc = false">
        <MdCatalog
          :editorId="editorId"
          :scrollElement="contentBodyEl"
          :theme="isDarkTheme ? 'dark' : 'light'"
        />
      </div>
    </aside>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, nextTick, watch } from 'vue'
import axios from 'axios'
import { DOCS_API_BASE } from '../../utils/docsApi'
import { useRoute, useRouter } from 'vue-router'
import { eventBus } from '@/utils/eventBus'

import FileTree from './FileTree.vue'
import { MdPreview, MdCatalog, config } from 'md-editor-v3'
import { configureDocsMarkdown } from '../../utils/docsSecurity'

config({ markdownItConfig: configureDocsMarkdown })
import 'md-editor-v3/lib/preview.css'

const editorId = 'preview-only'
const markdownText = ref('# Loading...')
const dirItems = ref([])
const fileItems = ref([])
const selectedItem = ref(null)
const markdownLoading = ref(false)
const listLoading = ref(false)
const listError = ref('')
const docMeta = ref({})
const showBackToTop = ref(false)
const currentVersionPath = ref('')
const searchTerm = ref('')
const showMobileToc = ref(false)
const relatedDocs = ref([])
const activeDocPath = ref('')

const isMobile = ref(false)
const sidebarVisible = ref(true)
const isDarkTheme = ref(true)
const readingProgress = ref(0)

const sidebarEl = ref(null)
const mainContentEl = ref(null)
const contentBodyEl = ref(null)

// API
const apiBase = DOCS_API_BASE
const listApi = `${apiBase}/list`
const contentApi = `${apiBase}/content`
const relatedApi = `${apiBase}/related`

// route
const route = useRoute()
const router = useRouter()
const pathQuery = ref(route.query.path || '')
const nameQuery = ref(route.query.name || '')

// 计算属性
const isStillLoading = computed(() => markdownText.value === '# Loading...')

const displayedItems = computed(() => {
  return [...dirItems.value, ...fileItems.value]
})

const wordCount = computed(() => {
  if (isStillLoading.value || markdownLoading.value) return 0
  return markdownText.value.replace(/[#*`\-[\]()]/g, '').length
})

const readingTime = computed(() => {
  return Math.max(1, Math.ceil(wordCount.value / 500))
})

// 监听窗口大小
const handleResize = () => {
  isMobile.value = window.innerWidth < 768
  if (!isMobile.value) {
    sidebarVisible.value = true
  }
}

// 监听滚动进度
const handleScroll = () => {
  if (!contentBodyEl.value) return
  const scrollTop = contentBodyEl.value.scrollTop
  const scrollHeight = contentBodyEl.value.scrollHeight - contentBodyEl.value.clientHeight
  readingProgress.value = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0
  showBackToTop.value = scrollTop > 300
}

function normalizePath(input) {
  if (!input) return ''
  return String(input).replace(/^\/+/, '').replace(/\/+$/, '')
}

async function fetchList(targetPath) {
  listLoading.value = true
  listError.value = ''
  try {
    const safePath = normalizePath(targetPath)
    const params = safePath ? { path: safePath } : undefined
    const res = await axios.get(listApi, { params })
    const data = res.data || {}
    dirItems.value = Array.isArray(data.dirs)
      ? data.dirs.map(dir => ({
          title: dir.title,
          path: normalizePath(dir.path),
          type: 'dir'
        }))
      : []
    fileItems.value = Array.isArray(data.files)
      ? data.files.map(file => ({
          title: file.title,
          path: normalizePath(file.path),
          versions: Array.isArray(file.versions)
            ? file.versions.map(ver => ({
                ...ver,
                path: normalizePath(ver.path)
              }))
            : [],
          type: 'file'
        }))
      : []
  } catch (err) {
    listError.value = err?.message || '目录加载失败'
    dirItems.value = []
    fileItems.value = []
    throw err
  } finally {
    listLoading.value = false
  }
}

onMounted(async () => {
  document.title = "文档中心 - VDS·欢乐，在此发生。"
  eventBus.emit('toggle-footer', false)

  handleResize()
  window.addEventListener('resize', handleResize)

  if (contentBodyEl.value) {
    contentBodyEl.value.addEventListener('scroll', handleScroll)
  }

  if (isMobile.value) {
    sidebarVisible.value = false
  }

  await handleRouteChange()
})

// 监听路由参数变化 (path 或 name)，实现导航响应
watch(() => route.query, (newQuery) => {
  pathQuery.value = newQuery.path || ''
  nameQuery.value = newQuery.name || ''
  handleRouteChange()
})

onBeforeUnmount(() => {
  eventBus.emit('toggle-footer', true)
  window.removeEventListener('resize', handleResize)
  if (contentBodyEl.value) {
    contentBodyEl.value.removeEventListener('scroll', handleScroll)
  }
})

function toggleSidebar() {
  sidebarVisible.value = !sidebarVisible.value
}

// function toggleTheme() {
//   isDarkTheme.value = !isDarkTheme.value
// }

function toggleFullscreen() {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen()
  } else {
    document.exitFullscreen()
  }
}

function copyLink() {
  const url = window.location.href
  navigator.clipboard.writeText(url).then(() => {
    // 可以添加提示
    console.log('链接已复制')
  })
}

function scrollToTop() {
  contentBodyEl.value?.scrollTo({ top: 0, behavior: 'smooth' })
}

async function onSelectItem(item) {
  if (isMobile.value) {
    sidebarVisible.value = false
  }

  if (item.type === 'file' && item.path) {
    const fullPath = normalizePath(item.path)
    const pathSegments = fullPath.split('/')
    pathSegments.pop()
    const dirPath = pathSegments.join('/')
    router.push({
      query: { path: dirPath, name: item.title }
    })
    return
  }

  if (item.type === 'dir') {
    router.push({
      query: { ...route.query, path: normalizePath(item.path), name: undefined }
    })
  }
}

async function switchVersion(newPath) {
  if (currentVersionPath.value === newPath) return
  currentVersionPath.value = newPath
  markdownLoading.value = true
  try {
    await loadFileContent(newPath)
  } finally {
    markdownLoading.value = false
  }
}

async function handleRouteChange() {
  const currentPath = normalizePath(pathQuery.value)
  try {
    await fetchList(currentPath)
  } catch (err) {
    markdownText.value = '# 加载失败\n\n文档暂时无法加载，请稍后重试。'
    selectedItem.value = null
    relatedDocs.value = []
    return
  }

  if (!currentPath && !nameQuery.value) {
    markdownText.value = '# 欢迎使用文档中心\n\n请从左侧选择一个文档开始阅读'
    selectedItem.value = null
    relatedDocs.value = []
    return
  }

  if (nameQuery.value) {
    const fileNode = fileItems.value.find(c => c.title === nameQuery.value)
    if (fileNode && fileNode.path) {
      markdownLoading.value = true
      currentVersionPath.value = fileNode.path
      selectedItem.value = fileNode
      loadFileContent(fileNode.path).catch(() => { /* loadFileContent sets a safe error message. */ }).finally(() => {
        markdownLoading.value = false
        nextTick(() => {
          if (contentBodyEl.value) {
            contentBodyEl.value.scrollTop = 0
          }
        })
      })
    } else {
      markdownText.value = '# 未找到\n\n此目录下没有找到该文档。'
      relatedDocs.value = []
      selectedItem.value = null
    }
    return
  }

  if (currentPath) {
    const introNode = fileItems.value.find(c => c.title === 'dir') || fileItems.value.find(c => c.title === 'index')
    if (introNode && introNode.path) {
      markdownLoading.value = true
      try {
        await loadFileContent(introNode.path)
        selectedItem.value = { ...introNode, title: '该目录的说明' }
      } catch (err) {
        markdownText.value = '# 加载失败\n\n目录说明暂时无法加载，请稍后重试。'
      } finally {
        markdownLoading.value = false
      }
    } else {
      markdownText.value = '# 目录\n\n这是一个文档目录，请选择子文档查看。'
      docMeta.value = {}
      relatedDocs.value = []
      selectedItem.value = null
    }
  }
}

async function loadFileContent(mdPath) {
  try {
    const safePath = normalizePath(mdPath)
    activeDocPath.value = safePath
    relatedDocs.value = [] // 重置相关文档
    const resp = await axios.get(contentApi, {
      params: { path: safePath }
    })

    // 后端现在返回 { content: "...", meta: { views: 1, ... } }
    markdownText.value = resp.data.content
    docMeta.value = resp.data.meta || {}

    // 加载相关文档 (不阻塞主内容显示)
    axios.get(relatedApi, { params: { path: safePath } })
      .then(res => {
        if (activeDocPath.value === safePath) {
          relatedDocs.value = res.data
        }
      })
      .catch(() => { /* Related content is optional. */ })

  } catch (err) {
    markdownText.value = '# 加载失败\n\n文档暂时无法加载，请稍后重试。'
    docMeta.value = {}
    throw err
  }
}

function getTags(meta) {
  if (!meta) return []
  const val = meta.keywords || meta.tags
  if (!val) return []
  if (Array.isArray(val)) return val
  return String(val).split(/[,，]/).map(s => s.trim()).filter(Boolean)
}

function goToRelated(doc) {
  router.push({
    query: {
      ...route.query,
      path: doc.dirPath,
      name: doc.fileName
    }
  })
}
</script>

<style scoped>
.reader-container {
  position: relative;
  width: 100vw;
  height: calc(100vh - 55px);
  display: flex;
  margin: 0;
  padding: 0;
  background: #0f0f14;
  overflow: hidden;
}

/* 移动端菜单按钮 */
.menu-button {
  position: fixed;
  top: 140px;
  left: 16px;
  z-index: 50;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: rgba(59, 130, 246, 0.9);
  border: 1px solid rgba(96, 165, 250, 0.3);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.menu-button:hover {
  transform: scale(1.05);
  background: #3b82f6;
}

.menu-button svg {
  width: 24px;
  height: 24px;
}

/* 侧边栏 */
.sidebar {
  width: 320px;
  background: #1a1a24;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  transition: transform 0.3s ease;
  position: relative;
  z-index: 1000;
}

.reader-container.mobile .sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translateX(-100%);
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.5);
}

.reader-container.mobile .sidebar.visible {
  transform: translateX(0);
}

.sidebar-header {
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.close-button {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.close-button:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.close-button svg {
  width: 18px;
  height: 18px;
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

/* 侧边栏搜索框 */
.sidebar-search {
  padding: 16px;
  background: #1a1a24;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  z-index: 10;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  width: 18px;
  height: 18px;
  color: #9ca3af;
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 10px 36px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  transition: all 0.2s ease;
}

.search-input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.08);
  border-color: #60a5fa;
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.1);
}

.clear-search {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
}

.clear-search:hover { color: #ef4444; }
.clear-search svg { width: 16px; height: 16px; }

.sidebar-footer {
  display: none;
  padding: 16px;
  background: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}

.stat-item svg {
  width: 16px;
  height: 16px;
  color: #60a5fa;
}

/* 遮罩层 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(2px);
}

/* 主内容区 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.content-header {
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  flex-wrap: wrap;
  gap: 12px;
}

.doc-info {
  flex: 1;
}

.doc-title {
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  margin: 0 0 6px 0;
}

.doc-meta {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #9ca3af;
  font-size: 14px;
}

.meta-item svg {
  width: 16px;
  height: 16px;
}

.version-selector {
  display: flex;
  align-items: center;
  gap: 8px;
}

.version-select {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  outline: none;
  cursor: pointer;
}

.version-select option {
  background: #1a1a24;
  color: #fff;
}

.tags-wrapper {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.doc-tag {
  background: rgba(255, 255, 255, 0.1);
  padding: 0 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #9ca3af;
}

.content-actions {
  display: flex;
  gap: 8px;
}

.action-button {
  width: 36px;
  height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  border-radius: 6px;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.action-button:hover {
  background: rgba(96, 165, 250, 0.08);
  border-color: rgba(96, 165, 250, 0.2);
  color: #60a5fa;
  transform: translateY(-1px);
}

.action-button svg {
  width: 18px;
  height: 18px;
}

.content-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  scroll-behavior: smooth;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6b7280;
  text-align: center;
  padding: 40px;
}

.empty-state svg {
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
  opacity: 0.3;
}

.empty-state h3 {
  font-size: 24px;
  color: #9ca3af;
  margin: 0 0 12px 0;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* 加载状态 */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #9ca3af;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 3px solid rgba(96, 165, 250, 0.1);
  border-top-color: #60a5fa;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Markdown外层包裹 */
.markdown-wrapper {
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
}

/* Markdown容器 */
.markdown-container {
  background: transparent;
  padding: 0 0 60px 0;
  min-height: 100%;
}

.markdown-container.light-theme {
  background: #ffffff;
  color: #1f2937;
}

/* 阅读进度条 */
.reading-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 2px;
  background: #60a5fa;
  transition: width 0.1s ease;
  z-index: 100;
}

/* 回到顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.9);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 90;
}

.back-to-top:hover {
  transform: translateY(-3px);
  background: #3b82f6;
}

.back-to-top svg {
  width: 24px;
  height: 24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 右侧目录 */
.toc-sidebar {
  width: 240px;
  background: #1a1a24;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.toc-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(255, 255, 255, 0.02);
}

.toc-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.toc-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

/* 移动端 TOC */
.mobile-toc {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 280px;
  z-index: 1002;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-toc.visible {
  transform: translateX(0);
}

.mobile-toc .toc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 覆盖 MdCatalog 样式 */
:deep(.md-editor-catalog-link) {
  color: #9ca3af !important;
  padding: 6px 12px !important;
  border-radius: 4px;
  font-size: 13px !important;
  line-height: 1.6;
  transition: all 0.2s;
}

:deep(.md-editor-catalog-link:hover),
:deep(.md-editor-catalog-active) {
  color: #60a5fa !important;
  background: rgba(255, 255, 255, 0.05);
}

/* 强制覆盖文档背景色变量 */
:deep(.md-editor) {
  --md-bk-color: #0f0f13;
}

/* 文档反馈 */
.doc-feedback {
  margin-top: 60px;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.doc-feedback p {
  color: #9ca3af;
  margin-bottom: 16px;
}

.feedback-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.feedback-btn {
  padding: 8px 20px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.feedback-btn:hover:not(:disabled),
.feedback-btn.active {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.5);
  color: #60a5fa;
}

/* 相关文档推荐 */
.related-docs {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.related-docs h3 {
  font-size: 16px;
  color: #fff;
  margin-bottom: 16px;
  font-weight: 600;
}

.related-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
}

.related-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 14px;
}

.related-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  transform: translateY(-2px);
}

/* 自定义滚动条 */
.sidebar-content::-webkit-scrollbar,
.content-body::-webkit-scrollbar {
  width: 8px;
}

.sidebar-content::-webkit-scrollbar-track,
.content-body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.02);
}

.sidebar-content::-webkit-scrollbar-thumb,
.content-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.sidebar-content::-webkit-scrollbar-thumb:hover,
.content-body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* 响应式 */
@media (max-width: 768px) {
  .sidebar {
    width: 280px;
  }
  
  .content-header {
    padding: 16px;
  }
  
  .doc-title {
    font-size: 20px;
  }
  
  .content-body {
    padding: 16px;
  }
  
  .markdown-container {
    padding: 20px;
  }
}
</style>
